import { render, staticRenderFns } from "./void_invoice_form.vue?vue&type=template&id=16b5a4c4&"
import script from "./void_invoice_form.vue?vue&type=script&lang=js&"
export * from "./void_invoice_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports